import { MATCH_STATUS_ALIASES } from '@/constants/match-statuses';
import { JOBS_QUERY_PARAMS } from '@/mixins/job-params';

// Route catchers for old email links

export const emailRedirects = [
  {
    path: '/jobs/response/:id/',
    redirect: {
      name: 'consumer::dashboard',
      params: {},
    },
  },
  {
    path: '/account/login/',
    redirect: {
      name: 'login',
    },
  },
  {
    path: '/jobs/response/:id/send-message',
    redirect: {
      name: 'consumer::dashboard',
      params: {},
    },
  },
  {
    path: '/jobs/response/:id/rate-review-payment/',
    redirect: {
      name: 'consumer::dashboard',
      params: {},
    },
  },
  {
    path: '/jobs/job-summary/:id/',
    redirect: {
      name: 'consumer::dashboard',
      params: {},
    },
  },
  {
    path: '/jobs/job/rate_pros/:id/',
    redirect: {
      name: 'consumer::dashboard',
      params: {},
    },
  },
  {
    path: '/ca_account/sandbox_login',
    redirect: to => to.query.next,
  },
  {
    path: '/ca_account/jobtrack/points/',
    redirect: { name: 'account::pro::points' },
  },
  {
    path: '/request_services',
    redirect: { name: 'homepage' },
  },
  {
    path: '/how_it_works',
    redirect: { name: 'homepage' },
  },
  {
    path: '/old_account/notifications/',
    redirect: { name: 'account::info' },
  },
  {
    path: '/my-home(.*)',
    redirect: { name: 'consumer::dashboard' },
  },
  {
    path: '/my-jobs',
    redirect: {
      name: 'dashboard',
    },
    children: [
      {
        path: 'dashboard',
        redirect: ({ query }) => ({
          name: 'dashboard::pro::jobs',
          params: {
            jobsStatusAlias: query.tab || MATCH_STATUS_ALIASES.new.key,
          },
        }),
        children: [
          {
            path: 'job/:id',
            redirect: ({ params, query }) => ({
              name: 'dashboard::pro::jobs',
              params: {
                jobsStatusAlias: query.tab || MATCH_STATUS_ALIASES.new.key,
                jobId: params.id,
              },
            }),
          },
        ],
      },
      {
        path: 'messages',
        redirect: {
          name: 'dashboard::pro::jobs',
          params: {
            jobsStatusAlias: MATCH_STATUS_ALIASES.potential.key,
          },
        },
        children: [
          {
            path: ':id',
            redirect: ({ params }) => ({
              name: 'dashboard::pro::jobs',
              params: {
                jobsStatusAlias: MATCH_STATUS_ALIASES.potential.key,
                jobId: params.id,
              },
            }),
          },
        ],
      },
      {
        path: 'notifications',
        redirect: {
          name: 'dashboard::pro::notifications',
        },
      },
      {
        path: 'search',
        redirect: ({ query: { query: oldQuery, ...query } }) => ({
          name: 'dashboard::pro::jobs',
          params: {
            jobsStatusAlias: MATCH_STATUS_ALIASES.search.key,
          },
          query: {
            ...query,
            [JOBS_QUERY_PARAMS.QUERY]: oldQuery,
          },
        }),
      },
      {
        path: 'history',
        redirect: {
          name: 'dashboard::pro::jobs',
          params: {
            jobsStatusAlias: MATCH_STATUS_ALIASES.past.key,
          },
        },
      },
    ],
  },
];
